import './base_filter_view.js.coffee';# Added by Script 
Namespace 'Monitoring.Views.SocialContents.Filters.PublicationsSession'

class Monitoring.Views.SocialContents.Filters.PublicationsSession.ContentsFilterView extends Monitoring.Views.SocialContents.Filters.PublicationsSession.BaseFilterView

  template: JST["backbone/templates/monitoring/filters/publications_session/contents_filter"]

  events:
    'click a.toggle': 'toggle'
    'click .removeAll': 'onRemoveAllFilters'

  initialize: ({options, filterContainerView, selectedProvider, topics, sortedAvailableChannelsByProvider}) ->
    dashboardResults = options.dashboardResults
    @searchQuery = options.searchQuery
    @facets = dashboardResults.facets
    @postFacets = dashboardResults.post_facets
    @tagsByClientCode = dashboardResults.tags_by_client_code || []
    @topics = topics || []
    @sortedAvailableChannelsByProvider = sortedAvailableChannelsByProvider
    @filterContainerView = filterContainerView
    @selectedProvider = selectedProvider
    @customTexts = Keepcon.customTexts

  onRemoveAllFilters: =>
    dateFiltersToPreserve = ['date_from_realtime', 'date_from', 'date_from_ISO', 'date_to', 'date_to_ISO', 'date_now']
    @preservePostsAndResetSearchQuery(dateFiltersToPreserve)
    @eventAggregator.trigger('searchQueryChanged', @searchQuery)

  preservePostsAndResetSearchQuery: (dateFiltersToPreserve) =>
    preservedDateFilters = {}
    dateFiltersToPreserve.forEach (field) =>
      preservedDateFilters[field] = @searchQuery.get(field)

    fb_posts = @searchQuery.get('fb_posts')
    twitter_posts = @searchQuery.get('twitter_posts')
    instagram_posts = @searchQuery.get('instagram_posts')
    tiktok_posts = @searchQuery.get('tiktok_posts')
    linkedin_posts = @searchQuery.get('linkedin_posts')
    youtube_posts = @searchQuery.get('youtube_posts')
    channels = @searchQuery.get('channels')

    @searchQuery.reset()

    dateFiltersToPreserve.forEach (field) =>
      @searchQuery.set(field, preservedDateFilters[field])

    @searchQuery.set('fb_posts', fb_posts)
    @searchQuery.set('twitter_posts', twitter_posts)
    @searchQuery.set('instagram_posts', instagram_posts)
    @searchQuery.set('tiktok_posts', tiktok_posts)
    @searchQuery.set('linkedin_posts', linkedin_posts)
    @searchQuery.set('youtube_posts', youtube_posts)
    @searchQuery.set('channels', channels)

  renderFilters: ->
    @facebookPublishedFilter = new Monitoring.Views.SocialContents.Filters.FacebookPublishedFilterView({searchQuery: @searchQuery, facet: @facets})
    @$el.find('#facebook_published_filter').html(@facebookPublishedFilter.render().el)

    @instagramPromotedFilter = new Monitoring.Views.SocialContents.Filters.InstagramPromotedFilterView({searchQuery: @searchQuery, facet: @facets})
    @$el.find('#instagram_promoted_filter').html(@instagramPromotedFilter.render().el)

    @fromPublishedFilterView = new Monitoring.Views.SocialContents.Filters.FromPublishedFilterView({ searchQuery: @searchQuery, facet: @facets })
    @$el.find('#facebook_is_from_published_filter').html(@fromPublishedFilterView.render().el)

    @customerTicketFilterView = new Monitoring.Views.SocialContents.Filters.CustomerTicketFilterView({ searchQuery: @searchQuery })
    @$el.find('#customer_ticket_filter').html(@customerTicketFilterView.render().el)

    @tagsFilterView = new Monitoring.Views.SocialContents.Filters.TagsFilterView({ searchQuery: @searchQuery, facet: @facets, tagsByClientCode: @tagsByClientCode })
    @$el.find('#general_tag_filter').html(@tagsFilterView.render().el)

    @keywordsFilterView = new Monitoring.Views.SocialContents.Filters.KeywordsFilterView({ searchQuery: @searchQuery, facet: @facets })
    @$el.find('#keyword_filter').html(@keywordsFilterView.render().el)

    @genderFilterView = new Monitoring.Views.SocialContents.Filters.GenderFilterView({ searchQuery: @searchQuery, facet: @facets })
    @$el.find('#gender_filter').html(@genderFilterView.render().el)

    @labelsFilterView = new Monitoring.Views.SocialContents.Filters.LabelsFilterView({ searchQuery: @searchQuery, facet: @facets })
    @$el.find('#label_filter').html(@labelsFilterView.render().el)

    @locationFilterView = new Monitoring.Views.SocialContents.Filters.LocationFilterView({ searchQuery: @searchQuery, facet: @facets })
    @$el.find('#location_filter').html(@locationFilterView.render().el)

    @moderatorFilterView = new Monitoring.Views.SocialContents.Filters.ModeratorFilterView({ searchQuery: @searchQuery, facet: @facets })
    @$el.find('#moderator_filter').html(@moderatorFilterView.render().el)

    @userFilterView = new Monitoring.Views.SocialContents.Filters.UserFilterView({ searchQuery: @searchQuery, facet: @facets })
    @$el.find('#user_filter').html(@userFilterView.render().el)

    @pageOwnerFilterView = new Monitoring.Views.SocialContents.Filters.PageOwnerFilterView({ searchQuery: @searchQuery, facet: @facets })
    @$el.find('#page_owner_filter').html(@pageOwnerFilterView.render().el)

    @statusFilterView = new Monitoring.Views.SocialContents.Filters.StatusFilterView({ searchQuery: @searchQuery, facet: @facets })
    @$el.find('#status_filter').html(@statusFilterView.render().el)

    @followersCountFilterView = new Monitoring.Views.SocialContents.Filters.FollowersCountFilterView({ searchQuery: @searchQuery, facet: @facets })
    @$el.find('#followers_count_filter').html(@followersCountFilterView.render().el)

    @genericUserFilterView = new Monitoring.Views.SocialContents.Filters.GenericUserFilterView({ searchQuery: @searchQuery, facet: @facets })
    @$el.find('#generic_user_filter').html(@genericUserFilterView.render().el)

    @reviewStatusFilterView = new Monitoring.Views.SocialContents.Filters.ReviewStatusFilterView({ searchQuery: @searchQuery, facet: @facets })
    @$el.find('#review_status_filter').html(@reviewStatusFilterView.render().el)

    @typeFilterView = new Monitoring.Views.SocialContents.Filters.TypeFilterView({ searchQuery: @searchQuery, facet: @facets })
    @$el.find('#type_filter').html(@typeFilterView.render().el)

    @dateFilterView = new Monitoring.Views.SocialContents.Filters.DateFilterView({ searchQuery: @searchQuery, facet: @facets, filtersContainer: @filterContainerView.filtersContainer() })
    @$el.find('#date_filter').html(@dateFilterView.render().el)

    @moderationDateFilterView = new Monitoring.Views.SocialContents.Filters.ModerationDateFilterView({ searchQuery: @searchQuery, facet: @facets, filtersContainer: @filterContainerView.filtersContainer() })
    @$el.find('#moderation_date_filter').html(@moderationDateFilterView.render().el)

    @languageFilterView = new Monitoring.Views.SocialContents.Filters.LanguageFilterView({ searchQuery: @searchQuery, facet: @facets })
    @$el.find('#language_filter').html(@languageFilterView.render().el)

    @sentimentFilterView = new Monitoring.Views.SocialContents.Filters.SentimentFilterView({ searchQuery: @searchQuery, facet: @facets })
    @$el.find('#sentiment_filter').html(@sentimentFilterView.render().el)

    @countryFilterView = new Monitoring.Views.SocialContents.Filters.CountryFilterView({ searchQuery: @searchQuery, facet: @facets })
    @$el.find('#country_filter').html(@countryFilterView.render().el)

    @customFacetsFilterView = new Monitoring.Views.SocialContents.Filters.CustomFacetsFilterView({ searchQuery: @searchQuery, facet: @facets })
    @$el.find('#custom_facets_filter').html(@customFacetsFilterView.render().el)

    @customTextsFilterView = new Monitoring.Views.SocialContents.Filters.CustomTextsFilterView({ searchQuery: @searchQuery, facet: @facets, customTexts: @customTexts })
    @$el.find('#custom_text_filter').html(@customTextsFilterView.render().el)

    @subtypeFilterView = new Monitoring.Views.SocialContents.Filters.SubtypeFilterView({ searchQuery: @searchQuery, facet: @facets })
    @$el.find('#subtype_filter').html(@subtypeFilterView.render().el)

    @googleMyBusinessFilters = new Monitoring.Views.SocialContents.Filters.GoogleMyBusinessFilters({searchQuery: @searchQuery})
    @$el.find('#google_my_business_filters').html(@googleMyBusinessFilters.render().el)

  renderAppliedFilters: ->
    @appliedTopicsView = new Monitoring.Views.SocialContents.Filters.AppliedTopicsView({ searchQuery: @searchQuery })
    @$el.find('#applied_topic').html(@appliedTopicsView.render().el)

    @appliedPosts = new Monitoring.Views.SocialContents.Filters.AppliedPostsView({ searchQuery: @searchQuery })
    @$el.find('#applied_posts').html(@appliedPosts.render().el)

    @appliedTagsNodeNameView = new Monitoring.Views.SocialContents.Filters.AppliedTagsNodeNameView({ searchQuery: @searchQuery })
    @$el.find('#applied_tags_node_name').html(@appliedTagsNodeNameView.render().el)

    @appliedOnlyTagsOfNodeName = new Monitoring.Views.SocialContents.Filters.AppliedOnlyTagsOfNodeName({ searchQuery: @searchQuery })
    @$el.find('#applied_only_tags_of_node_name').html(@appliedOnlyTagsOfNodeName.render().el)

    @appliedTagsView = new Monitoring.Views.SocialContents.Filters.AppliedTagsView({ searchQuery: @searchQuery, tagsByClientCode: @tagsByClientCode })
    @$el.find('#applied_general_tag').html(@appliedTagsView.render().el)

    @appliedGenderView = new Monitoring.Views.SocialContents.Filters.AppliedGenderView({ searchQuery: @searchQuery })
    @$el.find('#applied_gender').html(@appliedGenderView.render().el)

    @appliedLabelsView = new Monitoring.Views.SocialContents.Filters.AppliedLabelsView({ searchQuery: @searchQuery })
    @$el.find('#applied_label').html(@appliedLabelsView.render().el)

    @appliedLocationView = new Monitoring.Views.SocialContents.Filters.AppliedLocationView({ searchQuery: @searchQuery })
    @$el.find('#applied_location').html(@appliedLocationView.render().el)

    @appliedDiscoveredTopicsView = new Monitoring.Views.SocialContents.Filters.AppliedDiscoveredTopicsFilterView({ searchQuery: @searchQuery })
    @$el.find('#applied_discovered_topics').html(@appliedDiscoveredTopicsView.render().el)

    @appliedKeywordsView = new Monitoring.Views.SocialContents.Filters.AppliedKeywordsView({ searchQuery: @searchQuery })
    @$el.find('#applied_keyword').html(@appliedKeywordsView.render().el)

    @appliedModeratorView = new Monitoring.Views.SocialContents.Filters.AppliedModeratorView({ searchQuery: @searchQuery })
    @$el.find('#applied_moderator').html(@appliedModeratorView.render().el)

    @appliedUserView = new Monitoring.Views.SocialContents.Filters.AppliedUserView({ searchQuery: @searchQuery })
    @$el.find('#applied_user').html(@appliedUserView.render().el)

    @appliedPageOwnerView = new Monitoring.Views.SocialContents.Filters.AppliedPageOwnerView({ searchQuery: @searchQuery })
    @$el.find('#applied_page_owner').html(@appliedPageOwnerView.render().el)

    @appliedParentPostView = new Monitoring.Views.SocialContents.Filters.AppliedParentPostView({ searchQuery: @searchQuery })
    @$el.find('#applied_parent_post').html(@appliedParentPostView.render().el)

    @appliedStatusView = new Monitoring.Views.SocialContents.Filters.AppliedStatusView({ searchQuery: @searchQuery })
    @$el.find('#applied_status').html(@appliedStatusView.render().el)

    @appliedRatingView = new Monitoring.Views.SocialContents.Filters.AppliedRatingView({searchQuery: @searchQuery})
    @$el.find('#applied_rating_filter').html(@appliedRatingView.render().el)

    @appliedReviewStatusView = new Monitoring.Views.SocialContents.Filters.AppliedReviewStatusView({ searchQuery: @searchQuery })
    @$el.find('#applied_review_status').html(@appliedReviewStatusView.render().el)

    @appliedTypeView = new Monitoring.Views.SocialContents.Filters.AppliedTypeView({ searchQuery: @searchQuery })
    @$el.find('#applied_type').html(@appliedTypeView.render().el)

    @appliedHashtagView = new Monitoring.Views.SocialContents.Filters.AppliedHashtagView({ searchQuery: @searchQuery })
    @$el.find('#applied_hashtag').html(@appliedHashtagView.render().el)

    @appliedMentionView = new Monitoring.Views.SocialContents.Filters.AppliedMentionView({ searchQuery: @searchQuery })
    @$el.find('#applied_mention').html(@appliedMentionView.render().el)

    @appliedDateView = new Monitoring.Views.SocialContents.Filters.AppliedDateView({ searchQuery: @searchQuery })
    @$el.find('#applied_date').html(@appliedDateView.render().el)

    @appliedModerationDateView = new Monitoring.Views.SocialContents.Filters.AppliedModerationDateView({ searchQuery: @searchQuery })
    @$el.find('#applied_moderation_date').html(@appliedModerationDateView.render().el)

    @appliedLanguageView = new Monitoring.Views.SocialContents.Filters.AppliedLanguageView({ searchQuery: @searchQuery })
    @$el.find('#applied_language').html(@appliedLanguageView.render().el)

    @appliedSentimentView = new Monitoring.Views.SocialContents.Filters.AppliedSentimentView({ searchQuery: @searchQuery })
    @$el.find('#applied_sentiment').html(@appliedSentimentView.render().el)

    @appliedCountryView = new Monitoring.Views.SocialContents.Filters.AppliedCountryView({ searchQuery: @searchQuery })
    @$el.find('#applied_country').html(@appliedCountryView.render().el)

    @appliedCustomFacetsView = new Monitoring.Views.SocialContents.Filters.AppliedCustomFacetsView({ searchQuery: @searchQuery })
    @$el.find('#applied_custom_facets').html(@appliedCustomFacetsView.render().el)

    @appliedCustomTextsView = new Monitoring.Views.SocialContents.Filters.AppliedCustomTextsView({ searchQuery: @searchQuery })
    @$el.find('#applied_custom_texts').html(@appliedCustomTextsView.render().el)

    @appliedSubtypeView = new Monitoring.Views.SocialContents.Filters.AppliedSubtypeView({ searchQuery: @searchQuery })
    @$el.find('#applied_subtype').html(@appliedSubtypeView.render().el)

    @appliedSocialNetworkIdView = new Monitoring.Views.SocialContents.Filters.AppliedSocialNetworkIdView({ searchQuery: @searchQuery })
    @$el.find('#applied_social_network_id').html(@appliedSocialNetworkIdView.render().el)

    @appliedFollowersCountView = new Monitoring.Views.SocialContents.Filters.AppliedFollowersCountView({ searchQuery: @searchQuery })
    @$el.find('#applied_followers_count').html(@appliedFollowersCountView.render().el)

    @appliedGeolocationView = new Monitoring.Views.SocialContents.Filters.AppliedGeolocationView({ searchQuery: @searchQuery })
    @$el.find('#applied_geolocation').html(@appliedGeolocationView.render().el)

    @appliedFacebookPublishedFilter = new Monitoring.Views.SocialContents.Filters.AppliedPublishedFilterView({ searchQuery: @searchQuery })
    @$el.find('#applied_facebook_published_filter').html(@appliedFacebookPublishedFilter.render().el)

    @appliedInstagramPromotedFilter = new Monitoring.Views.SocialContents.Filters.AppliedInstagramPromotedFilterView({ searchQuery: @searchQuery })
    @$el.find('#applied_instagram_promoted_filter').html(@appliedInstagramPromotedFilter.render().el)

    @appliedFromPublishedFilter = new Monitoring.Views.SocialContents.Filters.AppliedFromPublishedView({ searchQuery: @searchQuery })
    @$el.find('#applied_facebook_is_from_published_filter').html(@appliedFromPublishedFilter.render().el)

    @appliedCustomerTicketFilterView = new Monitoring.Views.SocialContents.Filters.AppliedCustomerTicketFilterView({ searchQuery: @searchQuery })
    @$el.find('#applied_customer_ticket_filter').html(@appliedCustomerTicketFilterView.render().el)

    @appliedGenericUserView = new Monitoring.Views.SocialContents.Filters.AppliedGenericUserView({ searchQuery: @searchQuery })
    @$el.find('#applied_generic_user').html(@appliedGenericUserView.render().el)

  destroyFilters: ->
    @facebookPublishedFilter.destroy()
    @instagramPromotedFilter.destroy()
    @fromPublishedFilterView.destroy()
    @customerTicketFilterView.destroy()
    @tagsFilterView.destroy()
    @keywordsFilterView.destroy()
    @genderFilterView.destroy()
    @labelsFilterView.destroy()
    @locationFilterView.destroy()
    @moderatorFilterView.destroy()
    @userFilterView.destroy()
    @pageOwnerFilterView.destroy()
    @statusFilterView.destroy()
    @followersCountFilterView.destroy()
    @genericUserFilterView.destroy()
    @reviewStatusFilterView.destroy()
    @typeFilterView.destroy()
    @dateFilterView.destroy()
    @moderationDateFilterView.destroy()
    @languageFilterView.destroy()
    @sentimentFilterView.destroy()
    @countryFilterView.destroy()
    @customFacetsFilterView.destroy()
    @customTextsFilterView.destroy()
    @subtypeFilterView.destroy()
    @googleMyBusinessFilters.destroy()

  destroyAppliedFilters: ->
    @appliedTopicsView.destroy()
    @appliedPosts.destroy()
    @appliedTagsNodeNameView.destroy()
    @appliedOnlyTagsOfNodeName.destroy()
    @appliedTagsView.destroy()
    @appliedGenderView.destroy()
    @appliedLabelsView.destroy()
    @appliedLocationView.destroy()
    @appliedDiscoveredTopicsView.destroy()
    @appliedKeywordsView.destroy()
    @appliedModeratorView.destroy()
    @appliedUserView.destroy()
    @appliedPageOwnerView.destroy()
    @appliedParentPostView.destroy()
    @appliedStatusView.destroy()
    @appliedRatingView.destroy()
    @appliedReviewStatusView.destroy()
    @appliedTypeView.destroy()
    @appliedHashtagView.destroy()
    @appliedMentionView.destroy()
    @appliedDateView.destroy()
    @appliedModerationDateView.destroy()
    @appliedLanguageView.destroy()
    @appliedSentimentView.destroy()
    @appliedCountryView.destroy()
    @appliedCustomFacetsView.destroy()
    @appliedCustomTextsView.destroy()
    @appliedSubtypeView.destroy()
    @appliedSocialNetworkIdView.destroy()
    @appliedFollowersCountView.destroy()
    @appliedGeolocationView.destroy()
    @appliedFacebookPublishedFilter.destroy()
    @appliedInstagramPromotedFilter.destroy()
    @appliedFromPublishedFilter.destroy()
    @appliedCustomerTicketFilterView.destroy()
    @appliedGenericUserView.destroy()

  destroy: ->
    @destroyFilters()
    @destroyAppliedFilters()
    @remove()
    false
